import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, type Resolver } from 'react-hook-form';
import { Renter } from '../../utils/types/renter.interface';
import { renterSchema } from '../../utils/validator/RenterValidator';
import { RentCoverageTypes, SecurityDepositTypes } from '../../constants/CoverageType';

interface UseRenterInviteFormProps {
  selfEnrolledSDRLimit?: number;
  customCoverageDisabled?: boolean;
  useNewCoveragesOnLandlordInvite?: boolean;
}

const useRenterInviteForm = ({
  selfEnrolledSDRLimit,
  customCoverageDisabled,
  useNewCoveragesOnLandlordInvite,
}: UseRenterInviteFormProps) => {
  const {
    control,
    handleSubmit,
    setError,
    watch,
    formState,
    setValue,
    trigger,
    resetField,
    clearErrors,
  } = useForm<Renter>({
    mode: 'all',
    resolver: yupResolver(
      renterSchema(selfEnrolledSDRLimit, customCoverageDisabled, useNewCoveragesOnLandlordInvite),
    ) as Resolver<Renter>,
    defaultValues: {
      apartmentNumber: '',
      approvalStatus: '',
      customCoverage: false,
      applicantEmails: [{ value: '' }],
      securityDepositCoverage: SecurityDepositTypes.CompanyDefault,
      rentCoverage: RentCoverageTypes.CompanyDefault,
    },
    shouldUnregister: true,
  });

  return {
    control,
    formState,
    setError,
    handleSubmit,
    watch,
    setValue,
    trigger,
    resetField,
    clearErrors,
  };
};

export default useRenterInviteForm;
